// Shared date helpers — keep timezone logic in one place so the whole app rolls
// the day boundary at the same wall-clock time. Default is America/New_York
// (Eastern Time, DST-aware). Override per-call with `tz` if needed.

const FORMATTER_CACHE = new Map();
function formatter(tz) {
  if (!FORMATTER_CACHE.has(tz)) {
    FORMATTER_CACHE.set(tz, new Intl.DateTimeFormat("en-CA", {
      timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit",
    }));
  }
  return FORMATTER_CACHE.get(tz);
}

/** Returns `YYYY-MM-DD` for "today" in the given timezone. */
export function todayIn(tz = "America/New_York") {
  return formatter(tz).format(new Date()); // en-CA → ISO yyyy-mm-dd
}

/** Converts an absolute date (Date or ISO string) to `YYYY-MM-DD` in `tz`. */
export function isoDateIn(value, tz = "America/New_York") {
  const d = value instanceof Date ? value : new Date(value);
  return formatter(tz).format(d);
}
const STAMP_CACHE = new Map();
function stampFormatter(tz, withDate) {
  const key = `${tz}|${withDate}`;
  if (!STAMP_CACHE.has(key)) {
    STAMP_CACHE.set(key, new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      ...(withDate ? { month: "short", day: "numeric" } : {}),
      hour: "numeric", minute: "2-digit",
    }));
  }
  return STAMP_CACHE.get(key);
}

/** `3:41 PM` — clock time in Eastern, DST-aware. */
export function etTime(value, tz = "America/New_York") {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d) ? "" : stampFormatter(tz, false).format(d);
}

/** `Sep 6, 3:41 PM` — date + clock time in Eastern. */
export function etStamp(value, tz = "America/New_York") {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d) ? "" : stampFormatter(tz, true).format(d);
}

/** Whole days between two YYYY-MM-DD strings (b - a). Used to decide when a wallet
 *  has fallen far enough behind the rest of a selection to be worth naming. */
export function daysBetween(a, b) {
  if (!a || !b) return 0;
  const ms = Date.parse(`${String(b).slice(0, 10)}T00:00:00Z`) - Date.parse(`${String(a).slice(0, 10)}T00:00:00Z`);
  return Number.isFinite(ms) ? Math.round(ms / 86400000) : 0;
}
